/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Role_Delegation_InvalidInputs */

const en_error_role_delegation_invalid = /** @type {(inputs: Error_Role_Delegation_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The role cannot delegate that.`)
};

/**
* | output |
* | --- |
* | "The role cannot delegate that." |
*
* @param {Error_Role_Delegation_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_role_delegation_invalid = /** @type {((inputs?: Error_Role_Delegation_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Role_Delegation_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_role_delegation_invalid(inputs)
});